export const SET_REGISTERED_USER = 'signup/SET_REGISTERED_USER'
export const SET_USER = 'signup/SET_USERS'
